import { render, staticRenderFns } from "./DomainDnssec.vue?vue&type=template&id=2f6d8329&"
import script from "./DomainDnssec.vue?vue&type=script&lang=js&"
export * from "./DomainDnssec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports